import LanguageStrings from '../assets/LanguageStrings';

const DefaultConfig = require('../assets/SS360DefaultConfig.js');


const getModifiedValues = (values, defaults) => {
    if(defaults!==undefined && typeof values=="object" && !(values instanceof Array)){
        const res = {};
        for(let key of Object.keys(defaults)){
           if(values[key]!==undefined){
               res[key] = getModifiedValues(values[key], defaults[key]);
           }
           if(JSON.stringify(res[key])=="{}"){
               delete res[key];
           }
		}
		for(let key of Object.keys(values)) {
			if(defaults[key] === undefined) {
				res[key] = values[key];
			}
		}
        return res;
    }
    if(values===defaults){
        return undefined;
    }
    return values;
};

const isObject = function (el) {
	return el !== undefined && typeof el === 'object' && !(el instanceof Array);
};

const extend = (out, ...args) => {
	const output = out || {};
	for (let i = 0; i < args.length; i++) {
		const input = args[i];
		if (input) {
			Object.keys(input).forEach((key) => {
				if (input[key] !== undefined) {
					if (isObject(output[key]) && isObject(input[key])) {
						output[key] = extend(output[key], input[key]);
					} else {
						output[key] = input[key];
					}
				}
			});
		}
	}
	return output;
}; 

export default {
    removeDefaults(configObj, defaults){
		const res = {};
        for(let key of Object.keys(configObj)){
            if(defaults[key]!==undefined){
                try{
                    res[key] = JSON.parse(JSON.stringify(getModifiedValues(configObj[key], defaults[key])));
                }catch(ex){
                    // no JSON
                    if(key==="siteId" || defaults[key]!==configObj[key]){
                        res[key] = configObj[key];
                    }
                    // console.warn(key, configObj[key], defaults[key]);
                }
            }else{
                res[key] = JSON.parse(JSON.stringify(configObj[key]));
            }
            if(typeof res[key]==="object" && JSON.stringify(res[key])=="{}"){
                delete res[key];
            }
        }
        if(res.suggestions!==undefined && !res.suggestions.show && res.style!==undefined && res.style.suggestions!==undefined){
            delete res.style['suggestions'];
        }
		delete res['callbacks'];
        return res;
	},
	extend,
	getExtendedDefaults(language) {
		const defaults = JSON.parse(JSON.stringify(DefaultConfig));
		let lang = undefined;
		if (language === 'de') {
			lang = LanguageStrings.DE;
		} else if(language === 'fr') {
			lang = LanguageStrings.FR;
		} else if(language === 'nl') {
			lang = LanguageStrings.NL;
		} else {
			lang = LanguageStrings.EN;
		}
		Object.keys(lang).forEach((key) => {
			const target = defaults[key];
			extend(target, lang[key]);
		});
		return defaults;
	}
}


// WEBPACK FOOTER //
// ./src/utils/ConfigHelper.js